import React, { useState, useEffect } from 'react';
import { X, Search, CheckCircle, Store, Shield } from 'lucide-react';

function ShopModal({ show, onClose, user, shopSearchTerm, setShopSearchTerm, activeShopId, setActiveShopId, token }) {
  const [adminShops, setAdminShops] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && user?.role === 'admin') {
      fetchAdminShops();
    }
  }, [show]);

  const fetchAdminShops = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/shops', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      const data = await res.json();
      setAdminShops(data.map(s => ({ shop_id: s.id, shop_email: s.email })));
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  if (!show) return null;

  const shopsToShow = user?.role === 'admin' ? adminShops : (user?.assignments || []);
  const filteredShops = shopsToShow.filter(s => s.shop_email?.toLowerCase().includes(shopSearchTerm.toLowerCase()));

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-md z-[100] flex items-center justify-center p-6" onClick={onClose}>
      <div className="bg-slate-900 rounded-[50px] w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col shadow-2xl scale-in border border-white/5" onClick={e => e.stopPropagation()}>
        <div className="p-10 border-b border-white/5 flex justify-between items-center bg-white/5">
          <div>
            <h3 className="text-2xl font-black text-white flex items-center gap-3">
               {user?.role === 'admin' ? <Shield size={28} className="text-indigo-400"/> : <Store size={28} className="text-blue-400"/>}
               Do'konni Tanlang
            </h3>
            <p className="text-slate-500 text-sm font-bold mt-1">
               {user?.role === 'admin' ? "Barcha ro'yxatdan o'tgan do'konlar" : `Sizga biriktirilgan: ${shopsToShow.length} ta`}
            </p>
          </div>
          <button onClick={onClose} className="p-4 bg-white/5 text-slate-400 hover:text-rose-500 rounded-2xl shadow-sm transition"><X size={32}/></button>
        </div>

        <div className="p-8 bg-slate-900 border-b border-white/5">
          <div className="relative">
            <Search className="absolute left-6 top-1/2 -translate-y-1/2 text-slate-500" size={24}/>
            <input
              type="text"
              placeholder="Qidirish..."
              className="w-full pl-16 pr-6 py-6 bg-slate-950 border border-white/5 rounded-[30px] outline-none focus:ring-2 focus:ring-blue-500/20 font-black text-lg text-white placeholder-slate-700"
              value={shopSearchTerm}
              onChange={e => setShopSearchTerm(e.target.value)}
              autoFocus
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-8 pb-10 pt-4 space-y-3 bg-slate-900 custom-scrollbar">
          {loading ? (
             <div className="p-20 text-center text-slate-600 font-black animate-pulse">Ma'lumotlar yuklanmoqda...</div>
          ) : filteredShops.length === 0 ? (
             <div className="p-20 text-center text-slate-600 font-black">Hech qanday do'kon topilmadi</div>
          ) : (
            filteredShops.map((assign) => (
              <div
                key={assign.shop_id}
                onClick={() => { setActiveShopId(assign.shop_id); onClose(); }}
                className={`flex items-center justify-between p-6 rounded-[35px] cursor-pointer transition-all border-2 ${activeShopId === assign.shop_id ? 'border-blue-600 bg-blue-600/10 shadow-lg shadow-blue-900/20' : 'border-transparent bg-white/5 hover:bg-white/10'}`}
              >
                <div className="flex items-center gap-5">
                  <div className={`w-14 h-14 rounded-2xl flex items-center justify-center font-black text-xl ${activeShopId === assign.shop_id ? 'bg-blue-600 text-white' : 'bg-slate-800 text-slate-500 shadow-sm'}`}>
                    {assign.shop_email?.charAt(0).toUpperCase()}
                  </div>
                  <span className={`font-black text-lg ${activeShopId === assign.shop_id ? 'text-blue-400' : 'text-slate-300'}`}>{assign.shop_email}</span>
                </div>
                {activeShopId === assign.shop_id && <CheckCircle size={28} className="text-blue-500 shadow-[0_0_15px_rgba(59,130,246,0.5)]" />}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default ShopModal;
